import { AppName, type EventListViewModel } from "src/http/types";
import { usePageModelData } from "src/shared/context/PageModelDataContext";

/*
 * WARNING - DO NOT MOVE THIS FILE
 * This file location is important to ensure our linting enforces we avoid unsafely accessing page model data
 * across different applications and shared components within this repo.
 */

/**
 * Returns the page model data specifically for the performer page.
 */
export const usePerformerPageModelData = (): EventListViewModel => {
  const data = usePageModelData();
  if (data.appName !== AppName.Performer) {
    throw new Error("usePerformerPageModelData must be used on the performer page only");
  }
  return data;
};
